// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4t3i1wug{height:auto}
._p12f1osq{max-width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/image/dist/esm/ui/image/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,cAAc","sourcesContent":["._4t3i1wug{height:auto}\n._p12f1osq{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
